<template>
  <section class="wizard-form position-relative bg-white px-2 py-2" ref="wizardForm">
    <div class="p-2 mb-2">
      <div v-show="displayGenericErrors">
        <section id="target_errors"/>
      </div>
    </div>
    <div class="steps mt-4">
      <div class="step py-3 px-2" :class="{'step_active' : activeStep === 1}">
        <div class="text-center px-0 px-md-5">
          <div id="target_greeting_message"></div>
        </div>

        <div class="text-center">
          <input type="button" :value="translates.welcome_button_text" class="btn-primary"
                 :disabled="false"
                 @click.prevent="goNext(1)">
        </div>
      </div>

      <div class="step py-3 px-2" :class="{'step_active' : activeStep === 2}" data-step="2">
        <div class="text-center mb-4 px-0 px-md-5">
          <section id="target_bonus_message"/>
        </div>

        <div class="px-0 px-md-5" data-validation="true">
          <section id="target_bonus_selector"/>
          <section id="target_partner_selector"></section>
        </div>

        <section id="target_validator_partner"/>

        <div class="text-center mt-2">
          <input type="button" :value="translates.back" class="btn-outline-primary mr-2"
                 @click.prevent="goPrev(2)">
          <input type="button" :value="translates.next" class="btn-primary"
                 :disabled="isNextDisabled(2)"
                 @click.prevent="goNext(2)">
        </div>
      </div>

      <div class="step py-3 px-2" :class="{'step_active' : activeStep === 3}" data-step="3">
        <div class="text-center mb-4 px-0 px-md-5">
          <section id="target_codes_message"/>
        </div>

        <div class="px-0 px-md-5" data-validation="true">
          <section id="target_codes"/>

          <div class="d-flex align-items-center my-3">
            <section id="target_captcha"/>
          </div>
        </div>

        <div class="text-center mt-2">
          <input type="button" :value="translates.next" class="btn-primary"
                  :disabled="isNextDisabled(3)"
                 @click.prevent="goNext(3)">
        </div>
      </div>

      <div class="step py-3 px-2" :class="{'step_active' : activeStep === 4}" data-step="4">
        <div class="d-block d-md-none">
          <span class="back-link d-print-none d-inline-flex align-items-center mb-4" role="button" @click="goPrev(4)">
            <svg width="25" height="25" viewBox="0 0 25 25">
              <use href="#arrow-left" class="img-icon"/>
            </svg>
            <span class="ml-2 color-primary small">{{translates.back}}</span>
          </span>
        </div>

        <div class="text-center mb-4 px-0 px-md-5">
          <section id="target_user_data_message"/>
        </div>

        <div class="px-0 px-md-5" data-validation="true">
          <section id="target_inputs"/>
          <section id="target_agree_checkbox"/>
        </div>

        <section id="target_validator_user_data"/>

        <div class="text-center mt-2 d-flex align-center justify-content-center mx-auto">
          <div class="d-none d-md-block">
            <input type="button" :value="translates.back" class="btn-outline-primary mr-2"
                   @click.prevent="goPrev(4)">
          </div>
          <section id="target_submit" />
        </div>
      </div>
    </div>

    <div class="shared py-2 px-0 px-md-5">
      <div class="my-4 mx-2">
        <div id="target_terms" class="mt-4"/>
      </div>
    </div>
  </section>
</template>

<script>
const slotsList = [
  'errors',
  'greeting_message',
  'codes_message', 'codes', 'captcha',
  'bonus_message', 'partner_selector', 'bonus_selector', 'validator_partner',
  'user_data_message', 'inputs', 'agree_checkbox', 'submit', 'validator_user_data',
  'terms', 'error', 'success', 'loading', 'back_to_top',
];

const exceedClassNames = ['plm', 'phm', 'pam', 'unit', 'unit-1of2', 'unit-1of3', 'unit-2of3', 'unit-1of4', 'unit-3of4', 'unit-1of5', 'unit-1of10', 'unit-2of5', 'unit-3of5', 'unit-4of5', 'unit-5of5'];

export default {
  props: {
    i18n: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      $form: null,
      activeStep: 1,
      translates: JSON.parse(this.i18n),

      displayGenericErrors: true,

      nextDisabled: {
        1: false,
        2: true,
        3: false,
        4: true,
      }
    }
  },

  computed: {
    isNextDisabled() {
      return (step) => {
        return this.nextDisabled[step];
      }
    },
  },

  methods: {
    // todo: move this to utils
    removeClassesRecursively(element, classNames) {
      const that  = this;
      // If classNames is a string, convert it to an array
      if (typeof classNames === 'string') {
        classNames = [classNames];
      }

      // Remove specified classes from the current element
      classNames.forEach(className => {
        if (element.classList && element.classList.contains(className)) {
          element.classList.remove(className);
        }
      });

      // Recursively process child elements
      for (let i = 0; i < element.children.length; i++) {
        that.removeClassesRecursively(element.children[i], classNames);
      }
    },

    placeSlots() {
      slotsList.forEach((slotName) => {
        const fromArray = document.querySelectorAll(`[data-id="${slotName}"]`);
        const target = document.getElementById(`target_${slotName}`);

        [...fromArray].forEach((from) => {
          [...from.children].forEach((child) => {
            this.removeClassesRecursively(child, exceedClassNames)
            target.appendChild(child);
          });
        });
      });
    },

    async animateForm(step) {
      const isFormActive = step > 1;
      const $header = document.querySelector('.va-header');
      const $img = $header.querySelector('img');

      return new Promise(async (resolve) => {
        if ($img && !$img.complete) {
          await new Promise(res => {
            $img.addEventListener('load', res, { once: true });
            $img.addEventListener('error', res, { once: true });
          });
        }

        const { height } = $header.getBoundingClientRect();
        const offset = isFormActive ? height - 36 : 0;

        this.$refs.wizardForm.style.marginTop = `-${offset}px`;
        $header.classList.toggle('overlapped', isFormActive);

        resolve();
      });
    },

    focusOnErrors() {
      const errorStep = $('[data-type="first_error_step"]').attr('value');
      const mapSteps = [null, 'HelloText', 'PartnerSelection', 'Code', 'UserFields'];

      const step = errorStep ? mapSteps.indexOf(errorStep) : -1;

      if (step > 1) {
        this.activeStep = step;
      }
    },

    stepIsEmpty(step) {
      const $step = $(`[data-step=${step}]`);
      const $validation = $step.find('[data-validation]');

      if ($validation.length) {
        return !$validation.text().trim().length;
      }

      return true;
    },

    goNext(stepFrom) {
      const nextStep = stepFrom + 1;

      if (!this.stepIsEmpty(nextStep)) {
        this.activeStep = nextStep;
      } else {
        this.activeStep = nextStep + 1;
      }

      // check if there are any generic errors and hide it
      const $errors = $('#target_errors');
      this.displayGenericErrors = !($errors.text() || '').trim().length;
    },

    goPrev (stepFrom) {
      const prevStep = stepFrom - 1;

      if ((prevStep === 1) || !this.stepIsEmpty(prevStep)) {
        this.activeStep = prevStep;
      } else {
        this.activeStep = prevStep - 1;
      }
    },

    toggleStep(step, enabled) {
      this.nextDisabled[step] = !enabled;

      // custom handler for the last step(submit the form)
      if (step === 4) {
        const $button = $(`[data-step=${step}] input[type="submit"]`);

        if (enabled) {
          $button.removeAttr('disabled');
        } else {
          $button.attr('disabled', 'disabled');
        }
      }
    },
  },

  watch: {
    activeStep(step) {
      this.animateForm(step)
        .then(() => {
          if (step === 3) {
            this.$eventBus.$emit('focus:serial-number');
          }
        });
    }
  },

  mounted() {
    this.placeSlots();

    this.$eventBus.$on('wizard_step:toggle', this.toggleStep);

    this.$nextTick(() => {
      this.focusOnErrors();

      // disable last step submit button
      $(`[data-step="4"] input[type="submit"]`).attr('disabled', 'disabled');
    });
  },

  beforeDestroy() {
    this.$eventBus.$off('wizard_step:toggle');
  }
}
</script>
